import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { Reveal } from "../components/Reveal";
import { PageIntro } from "../components/PageIntro";
import { FinalCTA } from "../components/FinalCTA";
import { EventRow } from "../components/EventRow";
import eventsData from "../data/events.json";
import { archivedEventsByMonth } from "../lib/events";

function monthLabel(month, lang) {
  return new Date(`${month}-01T12:00:00Z`).toLocaleDateString(lang === "es" ? "es-ES" : "en-GB", { month: "long", year: "numeric" });
}

export default function PastEvents() {
  const { t, lang, pathFor } = useLang();
  const archive = archivedEventsByMonth(eventsData.upcoming, eventsData.pastByMonth);

  return (
    <>
      <PageIntro overline={t("eventsPage.archiveOverline")} title={t("eventsPage.archivePageTitle")} body={t("eventsPage.archivePageBody")} testId="past-events-intro" />
      <section className="bg-cream pb-24 lg:pb-32" data-testid="past-events-body">
        <div className="mx-auto max-w-7xl px-6 lg:px-10">
          <Link to={pathFor("/events")} data-testid="past-events-back-link" className="mb-12 inline-flex items-center gap-2 text-sm font-semibold text-terracotta transition-colors hover:text-terracotta-deep">
            <ArrowLeft className="h-4 w-4" /> {t("eventsPage.backToEvents")}
          </Link>
          {archive.length ? archive.map((group, index) => (
            <section key={group.month} className={index ? "mt-16" : ""} data-testid={`past-events-month-${group.month}`}>
              <Reveal>
                <h2 className="mb-6 font-serif text-4xl capitalize text-charcoal">{monthLabel(group.month, lang)}</h2>
              </Reveal>
              <div className="border-t border-border">
                {group.events.map((event, eventIndex) => (
                  <Reveal key={event.id} delay={eventIndex * 0.04}>
                    <EventRow event={event} lang={lang} archived />
                  </Reveal>
                ))}
              </div>
            </section>
          )) : <p className="py-10 text-charcoal/50" data-testid="past-events-empty">{t("eventsPage.archiveEmpty")}</p>}
        </div>
      </section>
      <FinalCTA />
    </>
  );
}